// extracted by mini-css-extract-plugin
module.exports = {"block":"_3nJU0O","block__linkRow":"_3grup5"};